const CARTEIRA_TIPO = {
  T: {
    id: "T",
    label: "Terceiros",
    sigla: "T",
    descricao: "Terceiros",
  },
  P: {
    id: "P",
    label: "Própria",
    sigla: "P",
    descricao: "Própria",
  },
  G: {
    id: "G",
    label: "Gerencial",
    sigla: "G",
    descricao: "Gerencial",
  },
  S: {
    id: "S",
    label: "Simulada",
    sigla: "S",
    descricao: "Simulada",
  },
  C: {
    id: "C",
    label: "Custodiante",
    sigla: "C",
    descricao: "Custodiante",
  },
};

export default CARTEIRA_TIPO;
